// NPM imports

import React, { Component } from 'react'

// Component

import './styles.css'

class NotFound extends Component {
    render() {
        return (
            <div className="NotFound">
                <h1 className="NotFound__title">404</h1>
                <p className="NotFound__text">A página que você está tentando acessar não existe ou talvez você não tenha permissão para acessá-la.</p>
            </div>
        )
    }
}

export default NotFound
